import Component from '@glimmer/component'
import { Report } from 'teacher-ui-client/components/reporting/reading-eggspress/dashboard/student/read-aloud-fluency/events/report'
import type ReportingService from 'teacher-ui-client/services/reporting'
import { service } from '@ember/service'
import { Product } from 'teacher-ui-client/utils/products'
import { trackedFunction } from 'reactiveweb/function'
import { toRequestScopeStudent } from 'teacher-ui-client/services/reporting'
import type { NormalizedInterval } from 'date-fns'
import type Student from 'teacher-ui-client/models/student'
import { keepLatest } from 'reactiveweb/keep-latest'
import { use } from 'ember-resources'
import { t } from 'ember-intl'
import type { ReportData } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/student/events/report-loader'

interface ReportLoaderSignature {
  Args: {
    period: NormalizedInterval
    student: Nullable<Student>
  }
}

export class ReportLoader extends Component<ReportLoaderSignature> {
  @service reporting!: ReportingService

  fetchReport = trackedFunction(this, async () => {
    if (!this.args.student?.id) return undefined

    const url = this.reporting.buildGravityUrl({
      product: Product.REX,
      requestScope: toRequestScopeStudent(this.args.student.id),
      reportName: 'student-dashboard/read-aloud-fluency/events',
    })
    const query = this.reporting.buildQuery({
      sort: '-created_at',
      page: { number: 1, size: 5 },
      period: this.args.period,
    })
    const report = await this.reporting.fetchReport<ReportData>(url, query)
    return report.events.length ? report : null
  })

  @use
  latestReport = keepLatest({
    value: () => this.fetchReport.value,
    when: () => this.fetchReport.isPending,
  }); /* prettier-ignore */ /* prettier-ignore-end */

  <template>
    {{#if this.latestReport}}
      <Report
        class="w-full"
        exportable={{t "pages.reporting.readingEggspress.dashboard.student.recentActivity"}}
        @events={{this.latestReport.events}}
        @isReloading={{this.fetchReport.isLoading}}
      />
    {{/if}}
  </template>
}

export default ReportLoader
